import React from "react";
import classNames from "classnames";
import Heading from "../../elements/Heading";
import getClassNameFactory from "../../utilities/classNames";
import { types } from "../../elements/Heading/HeadingTypes";

var PageHeadingWrapper = function PageHeadingWrapper(_ref) {
  var boldOrange = _ref.boldOrange,
      compact = _ref.compact,
      description = _ref.description,
      heading = _ref.heading,
      large = _ref.large;
  var getClassName = getClassNameFactory(PageHeadingWrapper.displayName);
  return /*#__PURE__*/React.createElement("h1", {
    className: getClassName({
      modifiers: classNames({
        compact: compact,
        large: large
      })
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "heading"
    })
  }, /*#__PURE__*/React.createElement(Heading, {
    type: types.ExtraLarge,
    boldOrange: boldOrange
  }, heading)), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "description"
    })
  }, description));
};

PageHeadingWrapper.displayName = "PageHeadingWrapper";
export default PageHeadingWrapper;